import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { SeoHead } from '@/components/seo/SeoHead';

export default function MessengerOAuthResult() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
  const [message, setMessage] = useState('Processando...');

  useEffect(() => {
    const success = searchParams.get('success') === '1';
    const pageName = searchParams.get('page_name') || '';
    const error = searchParams.get('error');

    if (success) {
      setStatus('success');
      setMessage(pageName ? `Página: ${pageName}` : 'Messenger conectado');

      if (window.opener) {
        try {
          window.opener.postMessage({
            type: 'messenger-connected',
            pageName,
            success: true
          }, '*');
        } catch (e) {
          console.error('postMessage failed:', e);
        }
      }

      setTimeout(() => { window.close(); }, 1500);
    } else {
      setStatus('error');
      setMessage(error || 'Erro ao conectar Messenger');

      if (window.opener) {
        try {
          window.opener.postMessage({
            type: 'messenger-error',
            error: error || 'Unknown error',
            success: false
          }, '*');
        } catch (e) {
          console.error('postMessage failed:', e);
        }
      }
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <SeoHead title="Messenger | FabChat" noindex />
      <div className="bg-card border border-border rounded-2xl p-8 max-w-sm w-full text-center shadow-lg">
        <div className="text-2xl font-bold bg-gradient-to-r from-primary to-blue-500 bg-clip-text text-transparent mb-6">
          FabChat
        </div>

        {status === 'processing' && (
          <>
            <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mx-auto mb-4">
              <Loader2 className="w-8 h-8 text-muted-foreground animate-spin" />
            </div>
            <h1 className="text-lg font-semibold text-foreground mb-2">Processando...</h1>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-8 h-8 text-green-500" />
            </div>
            <h1 className="text-lg font-semibold text-foreground mb-2">Conectado com sucesso!</h1>
            <p className="text-sm text-muted-foreground mb-4">{message}</p>
            <p className="text-xs text-muted-foreground">Esta janela fechará automaticamente...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-8 h-8 text-destructive" />
            </div>
            <h1 className="text-lg font-semibold text-foreground mb-2">Erro na conexão</h1>
            <p className="text-sm text-muted-foreground mb-4 p-3 bg-destructive/10 rounded-lg border border-destructive/20">
              {message}
            </p>
            <button
              onClick={() => window.close()}
              className="px-6 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors"
            >
              Fechar
            </button>
          </>
        )}
      </div>
    </div>
  );
}
